import React, { useRef, useEffect, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import SwipeableDrawer from 'jd-library/SwipeableDrawer';
import { toggleUploadOptions, toggleLinkSlider, toggleCopySlider, toggleSearchImage, uploadImageFromLink } from '../../actions/upload-options';
import FileSelector from "../FileSelector";
import { openCamera, openGallery } from "../../pages/add-edit-item/appUtils/AppUtils";
import styles from './upload-options.scss';
import {
    onFileSelUpload,
    getImagePath
} from "../productImageUtils";
import {
    updateProductMedia,
    getProductData,
    setSelectedType
} from '../../actions/products';
import {
    toggleLibrarySlider
} from "../../actions/videoLibrary";
import { togglePhotoSlider, setJdPhotosData } from "../../actions/photosGallery";
// import { showToastMessage } from '../../actions/toastmessage';
import toastMessageActions from 'jd-library/toastMessageActions'
import historyHandler from 'jd-library/historyHandler'
import DropdownOptions from './DropdownOptions';
import BifurcateModel from '../../pages/listing/BifurcateModel';
import CopyImagesSlider from '../UploadOptions/CopyImages/CopyImagesSlider';
import { setProdFromListing } from '../../pages/listing/Notifications/redux/action';

const getSliderOptions = ({ uploadOptions }) => uploadOptions;
const getSession = ({ session }) => session;
const isLibraryOpen = ({ videoLibrary }) => videoLibrary.showLibrarySlider;
const getIsMobile = ({library}) => library.deviceData.isMobile;
const options = {
    image: {
        camera: {
            icon: 'icon-CameraOutline',
            text: 'Camera / Gallery',
            value: 'camera'
        },
        url: {
            icon: 'icon-url',
            text: 'Image Link',
            value: 'url'
        },
        jdGallery: {
            icon: 'icon-myImages',
            text: 'Justdial Gallery',
            value: 'jdGallery'
        },
        copyImage: {
            icon: 'icon-myImages',
            text: 'Copy Image',
            value: 'copyImages'
        },
        aiGallery: {
            icon: 'icon-AI-Generated-Photos',
            text: 'AI Generated Photos',
            value: 'aiGallery'
        }
    },
    video: {
        camera: {
            icon: 'icon-CameraOutline',
            text: 'Camera / Gallery',
            value: 'camera'
        },
        url: {
            icon: 'icon-youtube',
            text: 'YouTube Link',
            value: 'url'
        },
        library: {
            icon: 'icon-videoLibrary',
            text: 'Video Library',
            value: 'library'
        }
    }
};

const titleObj = {
    image: 'UPLOAD IMAGE',
    video: 'UPLOAD VIDEO'
}

const getOptionKeys = (type, hasLibrary, isAndroidApp, isVariant, isEnrich = false,showAIoption = false) => {
    if (type == 'image' || !hasLibrary) {
        let imageArr = [];
        if (isAndroidApp) {
            imageArr = ['camera', 'cameraApp', 'url'];
        } else {
            if (isEnrich || (!hasLibrary && type == 'video')) {
                imageArr = ['camera', 'url'];
            } else {
                imageArr = ['camera', 'url', 'jdGallery'];
            }
        }
        if(isVariant){
            imageArr.splice(2,0,'copyImage', 'photoGallery');
        }
        showAIoption && imageArr.push('aiGallery');
        return imageArr;
    }

    return ['camera', 'url', 'library'];
}

const sliderKey = 'uploadOptions-slider';

const UploadOptions = props => {
    const fileSelector = useRef(null);
    const {
        type,
        data,
        style,
        containerInfo,
        prodFromListing=false
    } = props;
    const [bifurcateModel, showBifurcateModel] = useState({open : false,value : ''});
    const showAddEditProduct = useSelector(state => state.products.showAddEditProduct);
    const showAddEditProductOmni = useSelector(state => state.products.showAddEditProductOmni);
    const showEnrichEditProduct = useSelector(state => state.products.showEnrichEditProduct);
    const selectedCategoryType = useSelector(state => state.products.selectedCategoryType);
    const [showCopyImages, setCopyImages] = useState(false);
	const session = useSelector(getSession, shallowEqual);
    const libraryFlag = useSelector(isLibraryOpen);
    const isMobile = useSelector(getIsMobile, shallowEqual);
    const showAIoption = ['JDEMPLOYEE'].includes(session.user?.loggedUser?.userType) && session.showAIImages;
    const history = useHistory();
    const dispatch = useDispatch();
    const handleBack = useCallback(() => {
        dispatch(toggleUploadOptions({
            show: false,vendorSubMenu: false,isVariant: false,onFileUpload: null,variantIndex: ''
        }));
    }, []);
    useEffect(() => {
        if(props.isEnrich){
            session.videoExists = true;
        }
        if(historyHandler.getCurrentState() !== sliderKey){
            historyHandler.pushState(history, sliderKey);
        }
        historyHandler.addBackHandler(sliderKey, handleBack);
        return () => ()=> historyHandler.removeBackHandler(sliderKey,handleBack);
    }, []);
    const isB2B = (session.source == 'b2b');
    const optionKeys = data.options ? data.options : getOptionKeys(type, session.videoExists, props.isAndroidApp,props.isVariant, props.isEnrich,showAIoption);
    let optionObj = options[type];
    if(props.isVariant || session.viaOmni){
        optionObj['jdGallery'] = {
            icon: 'icon-myImages',
            text: 'Photo Library',
            value: 'jdGallery'
        }
    }
    if (!isB2B && type == 'image') {
        optionObj = {
            camera: {
                icon: 'icon-Image',
                text: 'Upload from Gallery',
                value: 'camera'
            },
            url: {
                icon: 'icon-Link',
                text: 'Upload from URL',
                value: 'url'
            }
        }
        if (props.isAndroidApp) {
            optionObj['cameraApp'] = {
                icon: 'icon-cameraNew',
                text: 'Camera',
                value: 'cameraApp'
            };
        }
        if(props.isVariant){
            optionObj['jdGallery'] = {
                icon: 'icon-myImages',
                text: 'Photo Library',
                value: 'jdGallery'
            }
        }
    } else if(!isMobile){

        optionObj['camera'] = {
            ...optionObj['camera']
        }
        optionObj['camera'].icon = 'icon-Image'
        optionObj['camera'].text = 'Gallery'
    }
    const list = optionKeys.map(key => optionObj[key]).filter((cur) => cur);
    const title = data.title || titleObj[type];

    const onFileChange = e => {
        if(props.customHandler){
            historyHandler.closeCurrent();
            props.customHandler(e);
            return;
        }
        const isAddProductPage = showAddEditProduct || showAddEditProductOmni;
        const isEnrchProductPage = showEnrichEditProduct;
        if ((!isAddProductPage && !isEnrchProductPage) && data.productId == 'ADD_PRODUCT') {
            historyHandler.closeCurrent();
            dispatch(toggleUploadOptions({
                show: false,vendorSubMenu: false,isVariant: false,onFileUpload: null,variantIndex: ''
            }));
            setTimeout(()=>{
                if(isMobile){
                    history.push("/products/add?selectedProductType="+selectedCategoryType);
                }else{
                    dispatch(getProductData({
                        productId : 'ADD_PRODUCT'
                    }));
                }
            }, 500)
        } else {
            if(!props.fromVideoListing) {
                historyHandler.closeCurrent();
            }
        }
        let addProps = {};
        switch (type) {
            case 'video': {
                addProps = {
                    forVideo: true
                }
            }
                break;
            case 'image': {
                addProps = {
                    imageUrlArr: data.imageUrlArr || []
                }
            }
                break;
        }
        if (libraryFlag) {
            history.goBack();
        }
        onFileSelUpload(e, {
            ...props,
            editProductId: data.productId,
            productId: data.productId,
            ...addProps,
            session,
            viaOmni: session.viaOmni,
            updateProductMedia: payload => {
                if(props.onFileUpload && !props.fromVideoListing){
                    props.onFileUpload(payload);
                    return;
                }
                return dispatch(updateProductMedia({
                    ...payload,
                    ignoreSave: data.ignoreSave,
                    dontReset: data.isDummyProductRow,
                    isAddEditProduct: showAddEditProduct,
                    isAddEditProductOmni:showAddEditProductOmni,
                    isEnrchProductPage: showEnrichEditProduct,
                    isEnrich: props.isEnrich
                }))
            },
            showToastMessage: data => dispatch(toastMessageActions.showMessage(data))
        });
        if (prodFromListing) {
            dispatch(setProdFromListing(true))
        } else {
            dispatch(setProdFromListing(false))
        }
    }
    const uploadForApp = (res) => {
        if (res.data) {
            let imgData = JSON.parse(res.data)[0];
            if (imgData.status === "success") {
                let actualImgPath = getImagePath(imgData.imgURL);
                let imgIndex = +new Date() + data.productId + 0;
                let dataObject = {
                    editProductId: data.productId,
                    forVideo: (type == 'video'),
                    imgIndex: imgIndex,
                    initialReq: false,
                    noOfFilesToUpload: 1,
                    source: session.source,
                    updateDefaultIndex: data.updateDefaultIndex,
                    imageUrl: {
                        actualPath: actualImgPath,
                        imgIndex: imgIndex,
                        imgURL: imgData.imgURL,
                        noOfFilesToUpload: 1,
                        uploaded: true,
                        productId: data.productId
                    },
                    ignoreSave: imgData.ignoreSave
                }
                dispatch(updateProductMedia({
                    ...dataObject
                }));
                dispatch(toggleUploadOptions({
                    show: false,vendorSubMenu: false,isVariant: false,onFileUpload: null,variantIndex: ''
                }));
            }
        } else {
            //Waiting to Upload
            console.log("waiting to upload");
        }
    }
    const cameraOptions = () => {
        openCamera({
            index: 0,
            callback: (res) => {
                uploadForApp(res);
            }
        });
    }

    const galleryOptions = () => {
        openGallery({
            index: 0,
            callback: (res) => {
                uploadForApp(res);
            }
        });
    }

    const onClick = (e, option, from) => {
        props.onUploadOptionClick && props.onUploadOptionClick(option.value);
        props.onUploadOptionClick && props.onUploadOptionClick(option.value);
        if(data.isDummyProductRow && Number(session?.newProfile) == 1){
            from = 'bifurcate'
        }
        if (props.vendorSubMenu && props.type == 'image') {
            // if (option.value == 'url') {
            //     toggleUploadFromUrl(true)
            //     return;
            // } else
            if (option.value == 'library') {
                updateShowUploadFromLibrary(true);
                return;
            } else if (option.value == "camera") {
                if(props.isVariant){
                    fileSelector.current.triggerClick(true);
                    return;
                }
                historyHandler.closeCurrent();
                if (deviceData.isAndroidApp && !deviceData.isIphoneApp && !window.jdInterface?.openNativeFileChooser) {
                    galleryOptions();
                } else {
                    props.onClickGallery();
                }
                return;
            } else if (option.value == 'copyImages'){
                historyHandler.closeCurrent();
                return setTimeout(() => {
                    dispatch(
                        toggleCopySlider({
                            show: true,
                            type: 'copy',
                            data: {
                                onSave: images=>props.onFileUpload({createdfrom: 'copyImages', imageUrlArr: images}),
                                variantProductData: props.variantProductData,
                                variantIndex: props.variantIndex,
                                imageUrlArr: props.data?.imageUrlArr || [],
                                showToastMessage: data => dispatch(toastMessageActions.showMessage(data))
                            }
                        })
                    )
                }, 300);
                return;
            }
        }
        switch (option.value) {
            case 'url':
                historyHandler.closeCurrent();
                return setTimeout(() => dispatch(toggleLinkSlider({
                    show: true,
                    type,
                    ...data,
                    productId: props.isVariant ? props.variantId || 'ADD_PRODUCT' : data.productId,
                    onFileUpload: props.customHandler ? props.updateProductImage : props.onFileUpload || null
                })), 300);
            case 'camera':
                if (props.isAndroidApp) {
                    galleryOptions();
                } else {
                    fileSelector.current.triggerClick(true);
                }
                break;
            case 'cameraApp':
                cameraOptions();
                break;
            case 'library':
                historyHandler.closeCurrent();
                setTimeout(() => dispatch(toggleLibrarySlider({
                    productId: data.productId,
                    flag: true,
                    ignoreSave: data.ignoreSave,
                    onFileUpload: props.isVariant || props.fromViewImageSlider ? props.onFileUpload : null,
                    isAddEditProduct: showAddEditProduct,
                    isAddEditProductOmni:showAddEditProductOmni,
                    isEnrchProductPage: showEnrichEditProduct,
                    fromViewImageSlider: props.fromViewImageSlider
                })), 300);
                break;
            case 'aiGallery':
                historyHandler.closeCurrent();
                if(!props.keywordId) {
                    props.updateError && props.updateError({"categoryName": "Please Select Category"});
                    dispatch(toastMessageActions.showMessage({message: 'Select Category To View AI Generated Photos',type: 'error'}));
                    return;
                }
                dispatch(setJdPhotosData({
                    productId: data.productId,
                    curImageUrl: (data.imageUrlArr || []).map((cur) => cur.imgURL).join(","),
                    categoryType: props.categoryType ? props.categoryType : data.categoryType ? data.categoryType : null
                }))
                setTimeout(() => {
                    dispatch(togglePhotoSlider({
                        displayOption: {
                            heading: 'AI Generated Photos',
                            noResultTxt: `No AI Generated Photos Available.<br> Please try again after some time`
                        },
                        isJdPhotoSlider: true,
                        isAISlider: true,
                        fromListing: true,
                        selectPhotoSlider: true,
                        keywordId: props.keywordId,
                        productId: data.productId,
                        isAddEditProduct: showAddEditProduct,
                        isEnrchProductPage: showEnrichEditProduct,
                        directAddToProduct: props.onFileUpload,
                        onSave: (res)=> {
                            historyHandler.closeCurrent();
                            const selectedImages = res.vendorImages.filter((item, index)=>res.selectedImages.indexOf(index) != '-1')
                            if((props.isVariant || props.fromViewImageSlider) && props.onFileUpload){
                                props.onFileUpload({imageUrlArr: selectedImages, createdfrom: "photoGallery"})
                                return;
                            }
                        }
                    }))
                }, 300);             
                break;
            case 'jdGallery':
                historyHandler.closeCurrent();
                if(props.customHandler) {
                    return setTimeout(() => dispatch(toggleSearchImage({
                        show: true,
                        type,
                        ...data,
                        updateProductImage: props.updateProductImage
                    })), 300);
                }
                dispatch(setJdPhotosData({
                    productId: data.productId,
                    curImageUrl: (data.imageUrlArr || []).map((cur) => cur.imgURL).join(","),
                    categoryType: props.categoryType ? props.categoryType : data.categoryType ? data.categoryType : null
                }))
                // if (isMobile && !props.isVariant) {
                //     /* dispatch(togglePhotoSlider({
                //         isJdPhotoSlidervideoLibrary: true,
                //         selectPhotoSlider: true,
                //     })) */
                //     setTimeout(() => {
                //         history.push('/products/jd-photos?dummyAddProduct=true')
                //     }, 300)
                // } else {
                    // web case
                    if(props.isVariant){
                        setTimeout(() => {
                            dispatch(togglePhotoSlider({
                                isJdPhotoSlider: false,
                                selectPhotoSlider: true,
                                directAddToProduct: true,
                                isVariant: true,
                                imageUrlArr: props.isVariant && props.variantProductData?props.variantProductData[props.variantIndex]?.imageUrlArr:[],
                                onSave: (res)=> {
                                    historyHandler.closeCurrent();
                                    const selectedImages = res.vendorImages.filter((item, index)=>res.selectedImages.indexOf(index) != '-1')
                                    if(props.isVariant && props.onFileUpload){
                                        props.onFileUpload({imageUrlArr: selectedImages, createdfrom: "photoGallery"})
                                        return;
                                    }
                                }
                            }))
                        }, 100);
                    }else{
                    setTimeout(() => {
                        dispatch(togglePhotoSlider({
                            isJdPhotoSlider: props.isVariant || session.viaOmni ?false:true,
                            selectPhotoSlider: true,
                            dummyAddProduct: from == 'bifurcate',
                            directAddToProduct: props.isVariant || props.onFileUpload,
                            isVariant: props.isVariant,
                            fromListing: true,
                            productId: data.productId,
                            isAddEditProduct: showAddEditProduct,
                            isAddEditProductOmni:showAddEditProductOmni,
                            isEnrchProductPage: showEnrichEditProduct,
                            imageUrlArr: props?.data?.imageUrlArr,
                            onSave: (res)=> {
                                historyHandler.closeCurrent();
                                const selectedImages = res.vendorImages.filter((item, index)=>res.selectedImages.indexOf(index) != '-1')
                                if(!session.viaOmni) {
                                    let selectedImagesUrl = [];
                                    const uploadPromises = selectedImages
                                        .filter(curLink => curLink.imageUrl.includes('content.jdmagicbox'))
                                        .map(curLink =>
                                        new Promise(resolve => {
                                            dispatch(uploadImageFromLink({
                                            link: curLink.imageUrl,
                                            fromViewImageSlider: true,
                                            onFileUpload: (payload) => {
                                                selectedImagesUrl.push({...payload.imageUrlObj,imageUrl: payload.imageUrlObj.imgURL});
                                            }
                                            }, isSuccess => resolve(isSuccess)));
                                        })
                                    );
                                    Promise.all(uploadPromises).then(response => {
                                        props.onFileUpload({
                                            forVideo: false,
                                            imageUrl: {
                                                imgURL: true
                                            },
                                            createdfrom: 'photoGallery',
                                            imageUrlArr: selectedImagesUrl
                                        })
                                        res.saveCB && res.saveCB();
                                    });
                                    return;
                                }
                                if((props.isVariant || props.fromViewImageSlider || session.viaOmni) && props.onFileUpload){
                                    props.onFileUpload({imageUrlArr: selectedImages, createdfrom: "photoGallery"})
                                    res.saveCB && res.saveCB();
                                    return;
                                }
                            }
                        }))
                    }, 300)
                //}

                }
                break;
            default:
                console.log(option);
        }
    }

    const onDummyRowClick = (e,option) => {
        showBifurcateModel({
            open : true,
            value : option
        })
    }

    return (
        <div className={`${styles['upload-options']} upload-options ${session.hasGlassFooter ? 'ubl-footer-dropdown' : ''}`}>
            {!bifurcateModel.open && <DropdownOptions
                isVariant={!isMobile && props.isVariant}
                hideCross={isB2B ? false : true}
                horizontalBar={true}
                onHidden={() => {
                    historyHandler.closeCurrent();
                }}
                title={isB2B ? title : null}
                drawerOptions={list}
                onClick={(data.productId == 'ADD_PRODUCT' && data.isDummyProductRow && !Number(session?.newProfile)) ? onDummyRowClick : onClick}
                className={'image-select-options'}
                itemClassName={styles['single-option']}
                isMobile={isMobile}
                style={style}
                containerInfo={containerInfo}
            /> }
            <FileSelector
                onChange={onFileChange}
                ref={fileSelector}
                forVideo={type == 'video'}
            />
            {showCopyImages ? <CopyImagesSlider
                onHidden={()=>{historyHandler.closeCurrent()}}
                onSave={images=>props.onFileUpload({createdfrom: 'copyImages', imageUrlArr: images})}
                variantProductData={props.variantProductData}
                variantIndex={props.variantIndex}
                imageUrlArr={props.data?.imageUrlArr || []}
                showToastMessage={data => dispatch(toastMessageActions.showMessage(data))}
            />: null}
            {bifurcateModel.open &&
				 <BifurcateModel
				 	choosedType= {(prod)=>{
                        // historyHandler.closeCurrent();
                        dispatch(setSelectedType({selectedCategoryType:prod}));
                        onClick('',bifurcateModel.value,'bifurcate');
                        // showBifurcateModel({});
                    }}
				 	showBifurcateModel={()=>showBifurcateModel({})
                }
				 />
			}
        </div>
    );
}

export default props => {
    const sliderOptions = useSelector(getSliderOptions, shallowEqual);

    return sliderOptions.sliderType == 'upload' ? (
        <UploadOptions
            {...props}
            {...sliderOptions}
        />
    ) : null
};